<template>
  <b-modal
    centered
    size="lg"
    hide-footer
    hide-header
    v-model="show"
    body-class="rounded"
  >
    <form-wizard
      color="#5540d6"
      :title="null"
      :subtitle="null"
      finish-button-text="Submit"
      back-button-text="Previous"
      class="steps-transparent mb-3"
    >
      <tab-content title="Rules" icon="feather icon-file-text">
        <div
          class="font-wegiht-bold mb-2 px-1"
          v-if="
            competition.draw_down_value != null &&
            Number(competition.draw_down_weight) != 3
          "
        >
          <span class="text-bold"> - Drawdown percentage: </span
          ><span class="text-success">
            {{
              competition.draw_down_value
                ? parseFloat(Number(competition.draw_down_value)) + "%"
                : "0"
            }}</span
          >
        </div>
        <div
          class="font-wegiht-bold mb-2 px-1"
          v-if="
            competition.starting_balance_value != null &&
            Number(competition.starting_balance_weight) != 3
          "
        >
          <span class="text-bold"> - Starting balance: </span
          ><span class="text-success">
            {{
              competition.starting_balance_value
                ? "$" + competition.starting_balance_value
                : "0"
            }}</span
          >
        </div>
        <div
          class="font-wegiht-bold mb-2 px-1"
          v-if="
            competition.minimum_trade_value != null &&
            Number(competition.minimum_trade_weight) != 3
          "
        >
          <span class="text-bold"> - Minimum number of trades: </span>

          <span class="text-success">
            {{
              competition.minimum_trade_value
                ? competition.minimum_trade_value
                : "0"
            }}</span
          >
        </div>
      </tab-content>

      <tab-content
        v-if="
          hasOwnNestedProperty(competition, 'conditions.length') &&
          competition.conditions.length
        "
        title="Conditions"
        icon="feather icon-user"
      >
        <template>
          <div
            class="font-wegiht-bold mb-2 px-1"
            v-for="(condition, index) in competition.conditions"
            :key="index"
          >
            {{ index + 1 + ". " + condition || "-" }}
          </div>
        </template>
        <!-- <template v-else>
          <div
            class="d-flex align-items-center justify-content-center h-100 new-alert"
          >
            <b-alert
              show
              variant="secondary"
              class="d-flex align-items-center justify-content-center p-3 h-100 w-100"
            >
              no information
            </b-alert>
          </div>
        </template> -->
      </tab-content>
      <tab-content
        title="Trading account"
        icon="feather icon-map-pin"
        :before-change="validationAccount"
      >
        <b-col lg="4">
          <validation-observer ref="account">
            <b-form-group label-for="account" class="w-100" label="account">
              <validation-provider
                #default="{ errors }"
                name="account"
                rules="required"
              >
                <select-box
                  v-model="account_id"
                  label="username"
                  select="id"
                  searchable
                  :url="`/panel/select-account/${$route.params.id}`"
                  :state="errors.length > 0 ? false : null"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </validation-observer>
        </b-col>
      </tab-content>
      <tab-content
        title="Payment"
        icon="feather icon-link"
        :before-change="validationPay"
      >
        <validation-observer ref="pay">
          <div class="py-1">
            <h4 class="font-weight-normal">
              Total pay amount {{ parseFloat(competition.fee) }} $
            </h4>
          </div>
          <b-form class="auth-add-user-form my-2" @submit.prevent="pay">
            <hr />
            <div class="my-2">
              <div
                class="w-100 d-flex align-items-center justify-content-end warning-button"
              >
                <label class="mr-50 mb-0 pt-25" for="pay-with-wallet"
                  >Pay with wallet</label
                >

                <b-form-checkbox
                  v-model="payWithWallet"
                  name="pay-with-wallet"
                  id="pay-with-wallet"
                  class="mr-0"
                  switch
                  inline
                  :uncheckedValue="0"
                  :value="1"
                >
                </b-form-checkbox>
              </div>
              <div
                class="my-1 d-flex align-items-center"
                v-if="payWithWallet && currentBalance"
              >
                <label class="mb-0 mr-50">Current balance:</label>
                <div>{{ parseFloat(currentBalance) }} $</div>
              </div>
              <b-form-group
                label-for="name"
                class="w-100"
                label="The amount of the payment from the wallet:"
                v-if="payWithWallet && currentBalance"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Amount"
                  :rules="`required|min-value:0|max-value:${
                    parseFloat(currentBalance) < parseFloat(competition.fee)
                      ? parseFloat(currentBalance)
                      : parseFloat(competition.fee)
                  }`"
                >
                  <b-form-input
                    min="0"
                    type="number"
                    id="Amount"
                    v-model="customPrice"
                    name="Amount"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </div>
            <hr
              v-if="
                payWithWallet
                  ? parseFloat(currentBalance) < parseFloat(competition.fee)
                    ? true
                    : parseFloat(customPrice) < parseFloat(competition.fee)
                  : true
              "
            />
            <b-form-group
              v-if="
                payWithWallet
                  ? parseFloat(currentBalance) < parseFloat(competition.fee)
                    ? true
                    : parseFloat(customPrice) < parseFloat(competition.fee)
                  : true
              "
              label-for="type"
              class="w-100"
              label="Choose a payment method"
            >
              <b-row>
                <b-col
                  class="d-flex"
                  md="4"
                  cols="6"
                  v-for="(item, index) in types"
                  :key="index"
                >
                  <div
                    @click="
                      type = item.value;
                      currency = item.currency ? item.currency : '';
                    "
                    :class="`shadow-lg rounded ${
                      type == item.value ? 'border-warning' : 'border'
                    } cursor-pointer d-flex align-items-center justify-content-center w-100 my-1 p-2`"
                    style="height: 80px"
                  >
                    <b-img
                      :alt="item.title"
                      :src="item.img"
                      fluid
                      style="max-height: 40px"
                    />
                  </div>
                </b-col>
                <b-col class="d-flex" cols="12">
                  <div
                    @click="
                      type = crypto.value;
                      currency = crypto.currency ? crypto.currency : '';
                    "
                    :class="`shadow-lg rounded ${
                      type == crypto.value ? 'border-warning' : 'border'
                    } cursor-pointer d-flex align-items-center justify-content-center w-100 my-50 p-1`"
                    style="height: 80px"
                  >
                    <h3>
                      {{ crypto.title }}
                    </h3>
                  </div>
                </b-col>
              </b-row>
            </b-form-group>
          </b-form>
        </validation-observer>
      </tab-content>

      <template slot="footer" slot-scope="props">
        <div class="d-flex align-items-center justify-content-between pt-2">
          <div class="wizard-footer-left">
            <div class="pl-1">
              <span
                >clicking next means you have
                <span class=" ">read and agreed </span> to the rules and
                conditions above.</span
              ><feather-icon
                icon="CheckIcon"
                class="bg-success rounded ml-50"
              />
            </div>
          </div>
          <div class="wizard-footer-right">
            <wizard-button
              v-if="!props.isLastStep"
              @click.native="props.nextTab()"
              class="wizard-footer-right"
              :style="props.fillButtonStyle"
              >Next</wizard-button
            >

            <wizard-button
              v-else
              @click.native="finish"
              class="wizard-footer-right finish-button"
              :style="props.fillButtonStyle"
            >
              {{ props.isLastStep ? "Submit" : "Next" }}</wizard-button
            >
          </div>
        </div>
      </template>
    </form-wizard>
    <loader :loading="loading" />
  </b-modal>
</template>

<script>
import {
  BRow,
  BImg,
  BModal,
  BButton,
  BCol,
  BButtonGroup,
  BFormGroup,
  BAlert,
  BForm,
  BFormCheckbox,
  BFormInput,
} from "bootstrap-vue";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import { required } from "@validations";
import Loader from "@core/components/loader/Loader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BRow,
    BImg,
    BCol,
    BButtonGroup,
    BModal,
    FormWizard,
    TabContent,
    BButton,
    WizardButton,
    ValidationProvider,
    ValidationObserver,
    SelectBox,
    BFormGroup,
    Loader,
    BAlert,
    BForm,
    BFormCheckbox,
    BFormInput,
  },
  props: {
    competition: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      payWithWallet: false,
      currentBalance: "",
      customPrice: "",
      type: "STRIPE1",
      account_id: "",
      loading: false,
      required,
      currency: "",
      crypto: {
        value: "NOW_PAYMENT1",
        title: "Pay with crypto",
        currency: "usdt",
      },
      types: [
        {
          value: "STRIPE1",
          title: "master card",
          img: require("@/assets/images/fxlegends/MasterCard-Logo-1990.png"),
        },
        {
          value: "STRIPE2",
          title: "visa card",
          img: require("@/assets/images/fxlegends/Visa_Inc._logo.svg.png"),
        },
        {
          value: "STRIPE3",
          title: "debit card",
          img: require("@/assets/images/fxlegends/debit.png"),
        },
        // {
        //   value: "NOW_PAYMENT1",
        //   title: "tether",
        //   img: require("@/assets/images/fxlegends/tether-1.svg"),
        //   currency: "usdt",
        // },
        // {
        //   value: "NOW_PAYMENT2",
        //   title: "btc",
        //   img: require("@/assets/images/fxlegends/btc1.png"),
        //   currency: "btc",
        // },
        // {
        //   value: "NOW_PAYMENT3",
        //   title: "etc",
        //   img: require("@/assets/images/fxlegends/etc.png"),
        //   currency: "etc",
        // },
      ],
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(val) {
        this.payWithWallet = false;
        this.$emit("input", val);
        this.$nextTick(() => this.$emit("validate"));
      },
    },
  },
  watch: {
    async payWithWallet(val) {
      if (val) {
        try {
          const { data } = await this.$http.get("panel/profile/user/wallet");
          this.currentBalance = data.current_balance;
          if (
            parseFloat(this.currentBalance) < parseFloat(this.competition.fee)
          ) {
            this.customPrice = parseFloat(this.currentBalance);
          } else {
            this.customPrice = parseFloat(this.competition.fee);
          }
        } catch (error) {}
      } else {
        this.customPrice = "";
      }
    },
  },
  methods: {
    validationPay() {
      return new Promise((resolve, reject) => {
        this.$refs.pay.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    validationAccount() {
      return new Promise((resolve, reject) => {
        this.$refs.account.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    async finish() {
      this.loading = true;
      try {
        let pay = {};
        if (!this.payWithWallet) {
          pay = {
            type: this.type.includes("STRIPE") ? "STRIPE" : "NOW_PAYMENT",
            account_id: this.account_id,
          };
          !this.type.includes("STRIPE") && (pay.currency = this.currency);
        } else {
          if (
            parseFloat(this.currentBalance) < parseFloat(this.competition.fee)
          ) {
            pay = {
              type: this.type.includes("STRIPE") ? "STRIPE" : "NOW_PAYMENT",
              use_wallet: this.customPrice,
              account_id: this.account_id,
            };
            !this.type.includes("STRIPE") && (pay.currency = this.currency);
          } else {
            pay = {
              use_wallet: this.customPrice,
              account_id: this.account_id,
            };
            if (
              parseFloat(this.customPrice) < parseFloat(this.competition.fee)
            ) {
              pay = {
                type: this.type.includes("STRIPE") ? "STRIPE" : "NOW_PAYMENT",
                use_wallet: this.customPrice,
                account_id: this.account_id,
              };
              !this.type.includes("STRIPE") && (pay.currency = this.currency);
            }
          }
        }
        const { data } = await this.$http.post(
          `/panel/competitions/${this.$route.params.id}/subscribe`,
          { ...pay }
        );
        if (data.pay_with_wallet) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Competition register done",
              icon: "EditIcon",
              variant: "success",
            },
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          window.location.assign(data.payment.url);
        }
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
